"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ColumnHeader = function ColumnHeader(_ref) {
  var _classNames;

  var text = _ref.text,
      width = _ref.width,
      onClick = _ref.onClick;
  var headerClass = (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, "co-grid__column--".concat(width), !!width), _defineProperty(_classNames, "header", !!onClick), _classNames));
  return _react.default.createElement("th", {
    className: headerClass,
    onClick: onClick
  }, _react.default.createElement("span", null, text));
};

ColumnHeader.propTypes = {
  text: _propTypes.default.string.isRequired,
  width: _propTypes.default.number,
  onClick: _propTypes.default.func
};
var _default = ColumnHeader;
exports.default = _default;
ColumnHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ColumnHeader",
  "props": {
    "text": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "width": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};